import { useObserver } from 'mobx-react-lite';
import React from 'react';
import ViewStateContainer from '../Core/ViewStateContainer/ViewStateContainer';
import KitchenDisplayVM from './KitchenDisplay';
import { useKitchenDisplay } from './KitchenDisplayStore';
import { DSOrder } from './StatusTypeList.stories';

KitchenDisplayPage.propTypes = {};

export default function KitchenDisplayPage() {
  const kitchenDisplayStore = useKitchenDisplay();

  const onStatusChanged = (order: DSOrder) => {
    kitchenDisplayStore.saveKitchenDisplayOrder(order);
  };

  return useObserver(() => (
    <ViewStateContainer
      state={kitchenDisplayStore.viewState}
      onReload={() => kitchenDisplayStore.reload()}
    >
      <KitchenDisplayVM
        kitchenDisplay={kitchenDisplayStore.kitchenDisplay}
        orders={kitchenDisplayStore.orders}
        onStatusChanged={onStatusChanged}
      />
    </ViewStateContainer>
  ));
}
